<div class="device-target-error-dialog-header">
  <mat-toolbar id="dialog-titlebar" color="primary">
    <div>Not Evaluable</div>
  </mat-toolbar>
</div>

<form [formGroup]="deviceTargetErrorForm" class="normal-form" (submit)="onSubmit()">
  <div mat-dialog-content class="device-target-error-dialog-content">
    <div class="device-target-error-controls-group">
      <div class="unevaluable-data-controls-message">
        Select the next checkbox only if the {{ deviceName === 'Savanna' ? 'entire cartridge' : 'entire device' }} is Not Evaluable:
      </div>
      <mat-checkbox (change)="onEntireCartridgeChange()" color="accent" [(ngModel)]="errorTargets[0].isActive"
        [ngModelOptions]="{standalone: true}" data-testid="dialog-entirecartridge-checkbox" [disabled]="isLoading || !(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')">
        {{ deviceName === 'Savanna' ? 'Entire cartridge' : 'Entire device' }} 
      </mat-checkbox>

      <ng-container *ngIf="deviceName === 'Savanna'">
        <div class="unevaluable-data-controls-message">
          Select the chamber(s)/channel(s) which is/are Not Evaluable:
        </div>
        <div style="display: flex;flex-wrap: wrap;padding-left: 30px;">
          <div *ngFor="let chamber of CHAMBERS_ARRAY; let iChamber = index;" style="flex:0 0 50%;">
            <mat-checkbox [disabled]="isLoading || errorTargets[(iChamber * CHAMBERS_NUM) + 1].disabled || !(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')"
              (change)="onChamberChange(iChamber + 1, $event.checked)" color="accent"
              [attr.data-testid]="'dialog-wholechamber-checkbox-' + (iChamber + 1)"
              [(ngModel)]="errorTargets[(iChamber * CHAMBERS_NUM) + 1].isActive" [ngModelOptions]="{standalone: true}">
              Whole chamber 0{{iChamber + 1}} is Not Evaluable
            </mat-checkbox>
            <div *ngFor="let channel of CHANNELS_ARRAY; let iChannel = index;" style="padding-left: 30px;">
              <mat-checkbox [disabled]="isLoading || errorTargets[(iChamber * CHAMBERS_NUM) + 2 + iChannel].disabled || !(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')"
                (change)="onChannelChange(iChamber + 1)" color="accent"
                [attr.data-testid]="'dialog-channel-checkbox-' + (iChamber + 1) + '-' + (iChannel + 1)"
                [(ngModel)]="errorTargets[(iChamber * CHAMBERS_NUM) + 2 + iChannel].isActive"
                [ngModelOptions]="{standalone: true}">
                Chamber 0{{iChamber + 1}} - Channel 0{{iChannel + 1}}
              </mat-checkbox>
            </div>
          </div>
        </div>
      </ng-container>

      <mat-form-field appearance="outline" class="device-target-error-field" subscriptSizing="dynamic">
        <mat-label>Error text</mat-label>
        <textarea matInput id="error-text" data-testid="dialog-errortext-textarea" formControlName="errorText" maxlength="2000"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions class="device-target-error-dialog-actions">
    <button mat-raised-button color="primary" type="button" data-testid="dialog-remove-button" *ngIf="hasError" (click)="onRemove()" [disabled]="isLoading || !(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')">
      Remove Not Evaluable
    </button>
    <button *ngIf="hasError" color="primary" mat-icon-button class="experiment-edit-icon" type="button"
      data-testid="dialog-help-button"
      matTooltip="This option is to remove the Not Evaluable check and delete the info saved previously, use it only in case you had mistakenly recorded a Not Evaluable.">
      <mat-icon>help</mat-icon>
    </button>
    <div class="separator"></div>
    <button mat-raised-button color="warn" type="button" data-testid="dialog-cancel-button" (click)="onCancel()" [disabled]="isLoading">Cancel</button>
    <button mat-raised-button color="primary" type="submit" data-testid="dialog-submit-button"
      [disabled]="deviceTargetErrorForm.invalid || isLoading || !hasErrorTargets() || !(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')">
      Submit
    </button>
  </div>
</form>